<template>
  <v-row justify="center">
    <v-dialog :value="open" @click:outside="closeDialog" scrollable max-width="500">
      <ValidationObserver ref="obs">
        <v-card :loading="loading">
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text"> Eliminar {{ title }} </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px"> Esta seguro que desea eliminar esta {{ title }}? </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog">Cancelar</v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="error"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="deleteAction()"
              >
                Eliminar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";

export default {
  props: {
    open: { type: Boolean },
    onDelete: { type: Function },
    title: { type: String },
  },
  components: { vuescroll },
  data() {
    return {
      loading: false,
    };
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    async deleteAction() {
      this.loading = true;
      const success = await this.onDelete();
      if (success) this.closeDialog();
      this.loading = false;
    },
  },
};
</script>
